const NAV_LINKS = [
  { label: "Home", href: "#home" },
  { label: "Services", href: "#services" },
  { label: "About", href: "#about" },
  { label: "Testimonials", href: "#testimonials" },
  { label: "Contact", href: "#contact" },
];

const serviceLinks = [
  "Bookkeeping Services",
  "QuickBooks Setup & Cleanup",
  "Financial Statements",
  "Payroll Processing",
  "Sales Tax Filing",
  "Financial Advisory",
];

const handleNav = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
  e.preventDefault();
  const target = document.querySelector(href);
  if (target) target.scrollIntoView({ behavior: "smooth" });
};

export default function Footer() {
  return (
    <footer className="bg-charcoal-900 text-white px-4 md:px-6 pt-10 md:pt-14 pb-8">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 md:gap-10 pb-10 md:pb-12 border-b border-charcoal-800/60">
          {/* Brand */}
          <div className="sm:col-span-2">
            <img
              src="https://storage.readdy-site.link/project_files/01f647ac-7c86-4957-a691-a312488d1835/b834e0b9-5147-41e6-9283-ddaf681edf2e_Gemini_Generated_Image_we2h8lwe2h8lwe2h.png?v=7910b91963806043e5a40ee3ce67ff55"
              alt="MTC Associates"
              className="h-12 w-auto object-contain mb-4"
            />
            <p className="text-charcoal-400 text-sm leading-relaxed max-w-xs mb-5 md:mb-6">
              Professional accounting, bookkeeping, and tax services for businesses
              and individuals across the United States. Remote-friendly. Trusted since 2010.
            </p>

          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white text-xs font-semibold mb-4 tracking-wide uppercase">Quick Links</h3>
            <ul className="space-y-2.5 md:space-y-3">
              {NAV_LINKS.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => handleNav(e, link.href)}
                    className="text-charcoal-400 hover:text-forest-300 text-sm transition-colors duration-200 cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white text-xs font-semibold mb-4 tracking-wide uppercase">Services</h3>
            <ul className="space-y-2.5 md:space-y-3">
              {serviceLinks.map((s) => (
                <li key={s}>
                  <a
                    href="#services"
                    onClick={(e) => handleNav(e, "#services")}
                    className="text-charcoal-400 hover:text-forest-300 text-sm transition-colors duration-200 cursor-pointer"
                  >
                    {s}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-3 md:gap-4 pt-5 md:pt-6 text-charcoal-500 text-xs">
          <p>&copy; {new Date().getFullYear()} MTC Associates. All rights reserved.</p>
          <div className="flex items-center gap-4">
            <a href="#" className="hover:text-forest-300 transition-colors cursor-pointer">Privacy Policy</a>
            <span>|</span>
            <a href="#" className="hover:text-forest-300 transition-colors cursor-pointer">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
